/**
 * Constantes pour la propriété rejectReason (Reject Reason BO)
 * Source: AbstractRfpModel.java - RR_*
 */

export enum PartnerRfpRejectReasonConstant {
    WRONG_CATEGORY = 1,
    TOO_SMALL = 2,              // @deprecated -> no_supplier
    CANNOT_CONTACT = 3,
    UNSERIOUS_BUYER = 4,
    WRONG_COUNTRIES = 5,
    DUPLICATE = 6,
    OTHER_BO = 7,               // @deprecated not used
    TEST = 8,
    DONT_UNDERSTAND = 9,        // @deprecated -> unserious buyer - client submits rfp without wanting to
    NO_SUPPLIER = 10,
    SPAM = 11,
    NOT_COMPANY = 12,           // @deprecated -> no_supplier
    OUT_FILTER = 13,            // @deprecated -> no_supplier  
    NOT_BOBEX_COUNTRIES = 14,
    NO_RELAUNCH_NEEDED = 15,
    TOO_LATE = 16,              // @deprecated
    NO_MEETING = 17,
    BAD_PUB = 18,
    VBK_RETURN = 20,
}
